
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/joy-ui/customization/using-css-variables",
      function () {
        return require("private-next-pages/joy-ui/customization/using-css-variables.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/joy-ui/customization/using-css-variables"])
      });
    }
  